<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>SOLICITAÇÕES DE REABERTURAS</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="$emit('atualizar-listagem')"
                            ></i>
                        </span>
                    </div>
                </h4>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <app-tabela
                    :itens="solicitacoesReaberturas"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-row>
                            <b-col sm="12">
                                <b-form inline class="justify-content-end">
                                    <label class="mr-sm-2">Status</label>
                                    <b-form-select
                                        class="mb-2 mr-sm-2 mb-sm-0"
                                        :plain="true"
                                        :options="statusLista"
                                        v-model="statusSelecionado"
                                    ></b-form-select>
                                </b-form>
                            </b-col>
                        </b-row>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <div class="justify-content">
                            <slot name="acoes" v-bind="data"></slot>
                            <btn-aprovar
                                class="ml-1"
                                v-if="mostrarBtnAprovar(data)"
                                :solicitacaoReabertura="data"
                                :solicitacoesReaberturasServicos="
                                    solicitacoesReaberturasServicos
                                "
                                @atualizar-listagem="
                                    $emit('atualizar-listagem')
                                "
                            ></btn-aprovar>
                            <btn-reprovar
                                class="ml-1"
                                v-if="mostrarBtnReprovar(data)"
                                :solicitacaoReabertura="data"
                                :solicitacoesReaberturasServicos="
                                    solicitacoesReaberturasServicos
                                "
                                @atualizar-listagem="
                                    $emit('atualizar-listagem')
                                "
                            ></btn-reprovar>
                            <btn-detalhe-reprovacao
                                class="ml-1"
                                v-if="mostrarBtnDetalharReprovacao(data)"
                                :solicitacaoReabertura="data"
                            ></btn-detalhe-reprovacao>
                        </div>
                    </template>
                    <template
                        slot="entrega.valorTotalEntregue"
                        slot-scope="data"
                        >{{
                            data.entrega.valorTotalEntregue | currency
                        }}</template
                    >
                    <template slot="entrega.natureza" slot-scope="data">
                        <app-status
                            :status="data.entrega.natureza"
                        ></app-status>
                    </template>
                    <template slot="entrega.valorHora" slot-scope="data">{{
                        data.entrega.valorHora | currency
                    }}</template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import BtnAprovar from './BtnAprovar'
import BtnReprovar from './BtnReprovar'
import BtnDetalheReprovacao from './BtnDetalheReprovacao'
import { solicitacaoReaberturaStatus } from './SolicitacaoReaberturaStatus'

export default {
    components: {
        BtnAprovar,
        BtnReprovar,
        BtnDetalheReprovacao
    },

    props: {
        solicitacoesReaberturas: {
            type: Array,
            default: () => []
        },

        solicitacoesReaberturasServicos: {
            type: Object,
            default: () => {}
        },

        perfil: {
            type: String,
            default: () => ''
        },

        permiteReprovar: {
            type: Boolean,
            default: () => false
        },

        permiteAprovar: {
            type: Boolean,
            default: () => false
        },

        statusPadrao: {
            type: Number,
            default: () => -1
        }
    },

    data() {
        return {
            erros: [],
            statusSelecionado: 0,
            statusLista: [
                { value: -1, text: 'TODAS' },
                { value: 0, text: 'EM ANÁLISE PELO GERENTE' },
                { value: 1, text: 'EM ANÁLISE PELA UABS' },
                { value: 2, text: 'REPROVADA PELO GERENTE' },
                { value: 3, text: 'REPROVADA PELA UABS' },
                { value: 4, text: 'APROVADA' },
                { value: 5, text: 'CANCELADA' }
            ],
            campos: [
                {
                    key: 'dataCadastro',
                    label: 'Data da Solicitação',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'entrega.contratacao.codContratacao',
                    label: 'Contratação',
                    filterable: true
                },
                {
                    key: 'entrega.contratacao.credenciado',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'entrega.descritivo',
                    label: 'Descritivo',
                    filterable: true
                },
                {
                    key: 'entrega.natureza',
                    label: 'Natureza',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'entrega.valorHora',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'entrega.dataEntrega',
                    label: 'Data da Entrega',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'entrega.cargaHorariaEntregue',
                    label: 'CH Entr.',
                    tdClass: 'text-center'
                },
                {
                    key: 'entrega.valorTotalEntregue',
                    label: 'Total Entregue',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                // {
                //     key: 'statusIdRm',
                //     label: 'Comprometimento'
                // },
                {
                    key: 'justificativa',
                    label: 'Justificativa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        mostrarBtnAprovar(data) {
            if (this.perfil == 'gerente') {
                return (
                    this.permiteAprovar &&
                    data.status ==
                        solicitacaoReaberturaStatus.EM_ANALISE_PELO_GERENTE
                )
            } else if (this.perfil == 'uabs') {
                return (
                    this.permiteAprovar &&
                    data.status ==
                        solicitacaoReaberturaStatus.EM_ANALISE_PELA_UABS
                )
            }
            return false
        },

        mostrarBtnReprovar(data) {
            if (this.perfil == 'gerente') {
                return (
                    this.permiteReprovar &&
                    data.status ==
                        solicitacaoReaberturaStatus.EM_ANALISE_PELO_GERENTE
                )
            } else if (this.perfil == 'uabs') {
                return (
                    this.permiteReprovar &&
                    data.status ==
                        solicitacaoReaberturaStatus.EM_ANALISE_PELA_UABS
                )
            }
            return false
        },

        mostrarBtnDetalharReprovacao(data) {
            return (
                data.status ==
                    solicitacaoReaberturaStatus.REPROVADA_PELO_GERENTE ||
                data.status == solicitacaoReaberturaStatus.REPROVADA_PELA_UABS
            )
        }
    },

    created() {
        this.statusSelecionado = this.statusPadrao
    },

    computed: {
        mostrarTabela() {
            return true
        }
    },

    watch: {
        statusSelecionado(newValue) {
            this.$emit('atualizar-status-selecionado', newValue)
        }
    }
}
</script>
